import cn from 'classnames';
import styles from './PrevNextButtons.module.scss';
import Prev from './../../../../../Icons/Prev.js';
import Next from './../../../../../Icons/Next.js';
import React from 'react';

export default function PrevNextButtons({ onPrev, onNext }) {
  return (
    <>
      <button className={cn(styles.button, styles.button_prev)} onClick={onPrev}>
        <Prev />
      </button>
      <button className={cn(styles.button, styles.button_next)} onClick={onNext}>
        <Next />
      </button>
    </>
  );
}
